import React, { useEffect, useState } from "react";
import styles from "./admin-dashboard.module.css";
import { Col, Row, Typography } from "antd";
import StatisticsCard from "../../../../components/statistics-card/statistics-card";
import { getAdminDashboardData } from "../../../../services/dashboard";
import StudentPresence from "../student-presence/student-presence";
import GenderDistributionCard from "../gender-distribution/gender-distribution";
import StaffAttendanceCard from "../staff-attendance/staff-attendance";
import UpcomingExamsCard from "../upcoming-exams/upcoming-exams";
import TeacherLeaveApprovalCard from "../teacher-leave-approval/teacher-leave-approval";
import UpcomingEventsCard from "../upcoming-events/upcoming-events";
import UnregisteredParentCard from "../unconnected-parent/unconnected-parent";

const statisticsCard = [
  {
    key: "totalTeachers",
    title: "Total Teachers",
    icon: "total-teacher-icon",
    iconBgColor: "#E05A21",
    card_bg_color: "#FFF3EE",
  },
  {
    key: "totalStudents",
    title: "Total Students",
    icon: "total-student-icon",
    iconBgColor: "#569BF6",
    card_bg_color: "#E9F3FF",
  },
  {
    key: "totalSubjects",
    title: "Total Subjects",
    icon: "total-subject-icon",
    iconBgColor: "#29C241",
    card_bg_color: "#F2FFF4",
  },
  {
    key: "totalClubs",
    title: "Total Clubs",
    icon: "total-club-icon",
    iconBgColor: "#7F56D9",
    card_bg_color: "#F5F0FF",
  },
  {
    key: "totalLevels",
    title: "Total Levels",
    icon: "total-level-icon",
    iconBgColor: "#4BCAFF",
    card_bg_color: "#E7F8FF",
  },
  {
    key: "totalParents",
    title: "Total Parents",
    icon: "total-parent-icon",
    iconBgColor: "#DFC356",
    card_bg_color: "#FFF9E2",
  },
  {
    key: "totalRooms",
    title: "Total Rooms",
    icon: "total-room-icon",
    iconBgColor: "#4BCAFF",
    card_bg_color: "#E7F8FF",
  },
];

const AdminDashboard = () => {
  const [statisticsData, setStatisticsData] = useState(null);
  const [genderData, setGendersData] = useState([]);

  useEffect(() => {
    getDashboardDetails();
  }, []);

  const getDashboardDetails = async () => {
    try {
      const response = await getAdminDashboardData();
      if (response?.data) {
        const responceData = response?.data?.data;
        setStatisticsData(responceData.overview);
        setGendersData(responceData.studentGenderDistribution);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const goToAddParent = () => {};

  return (
    <div className={styles.container}>
      <div>
        <Typography className={styles.header}>Overview</Typography>
        <Row
          gutter={[16, 16]}
          wrap
          style={{ margin: "16px 0", overflowX: "auto" }}
        >
          {statisticsCard?.map((item) => {
            const showValue = `${statisticsData?.[item?.key] ?? 0} ${
              item?.key === "monthlyRevenue" ? "Z$" : ""
            }`;
            return (
              <Col key={item.key} xs={24} sm={12} md={8} lg={6} xl={4}>
                <StatisticsCard
                  key={item?.key}
                  heading_text={item?.title}
                  statistic_value={showValue}
                  card_bg_color={item?.card_bg_color}
                  icon_name={item?.icon}
                  icon_fill={"none"}
                  icon_height={"28px"}
                  icon_width={"28px"}
                  icon_stroke={"white"}
                  icon_container_bg_color={item?.iconBgColor}
                />
              </Col>
            );
          })}
        </Row>
      </div>
      <div className={styles.mobileWrapper} style={{ marginTop: "20px" }}>
        <Typography className={styles.header}>Student Overview</Typography>
        <Row className={styles.equalHeightWrap} style={{ margin: "16px 0" }}
         gutter={[16, 16]}
         >
          <Col className={styles.equalCard} xs={24} md={15}>
            <StudentPresence />
          </Col>
          <Col className={styles.equalCard} xs={24} md={9}>
            <GenderDistributionCard genderDetails={genderData} />
          </Col>
        </Row>
      </div>
      <div className={styles.mobileWrapper} style={{ marginTop: "20px" }}>
        <Typography className={styles.header}>
          Staff & Teacher Overview
        </Typography>
        <Row  className={styles.equalHeightWrap} style={{ margin: "16px 0" }} gutter={[16, 16]}>
          <Col  className={styles.equalCard} xs={24} md={9}>
            <StaffAttendanceCard />
          </Col>
          <Col  className={styles.equalCard} xs={24} md={15}>
            <TeacherLeaveApprovalCard />
          </Col>
        </Row>

        <div className={styles.mobileWrapper} style={{ marginTop: "20px" }}>
          <Typography className={styles.header}>Calendar & Events</Typography>
          <Row  className={styles.equalHeightWrap} style={{ margin: "16px 0" }} gutter={[16, 16]}>
            <Col  className={styles.equalCard} xs={24} md={9}>
              <UpcomingEventsCard />
            </Col>
            <Col className={styles.equalCard}  xs={24} md={15}>
              <UpcomingExamsCard />
            </Col>
          </Row>
        </div>
        <div>
          <UnregisteredParentCard onAddParent={goToAddParent} />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
